import React, { Component } from 'react';
import Typography from "@material-ui/core/Typography";
import {withStyles} from "@material-ui/styles";
import Paper from "@material-ui/core/Paper";
import {organisationDetails, saveOrUpdateOrganisationDetails, exportReport} from "../../util/ApiUtils";
import {NotificationManager, NotificationContainer} from "react-notifications";
import MuiTable from "../common/MuiTable";
import {compareStrings} from "../../util/CommonUtils";
import * as CommonUtils from "../../util/CommonUtils";

const classes = (() => ({
    root: {
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

function createData(name, description, immutable) {
    return { name, description, immutable };
}

const rows = [
    createData('Competence', "Ability to apply knowledge and skills to achieve intended results.", true),
    createData('Contract', "Document with defined terms and conditions that have been agreed between the nominated parties entering into the contract.", true),
    createData('Corrective action', "Action to eliminate the cause of non conformity and to prevent recurrence.", true),
    createData('Environment', "Surroundings which an organisation operates, including air, water, land, natural resources, flora, fauna, human and their interrelationships.", true),
    createData('Integrated Management System (IMS)', "Quality, safety and environmental management system.", true),
    createData('Objective', "Result to be achieved.", true),
    createData('Consultation', "Seeking views before making a decision.", true),
    createData('Workplace', "Place under the control of the organisation where a person needs to be or to go for work purposes.", true),
    createData('Contractor', "External organisation providing services to an organisation in accordance with agreed specifications, terms and conditions.", true),
    createData('Requirement', "Need or expectation that is stated, generally implied or obligatory.", true),
    createData('Legal requirements and other requirements', "Legal requirements that an organisation has to comply with and other requirements that an organisation has to or chooses to comply with.", true),
    createData('Management system', "Set of interrelated or interacting elements of an organisation to establish policies and objectives and processes to achieve those objectives.", true),
    createData('Top management', "Person or group of people who directs and controls an organisation at the highest level.", true),
    createData('Effectiveness', "Extent to which planned activities are realised and planned results achieved.", true),
    createData('Occupational Health and Safety Policy', "Policy to prevent work-related injury and ill health to workers and to provide fast and healthy workplaces.", true),
    createData('Hazard', "Source with a potential to cause injury and ill health.", true),
    createData('Documented information', "Information required to be controlled and maintained by an organisation and the medium on which it is contracted.", true),
    createData('Process', "Set of interrelated or interacting activities which transforms nuts into outputs.", true),
    createData('Procedure', "Specified way to carry out an activity or a process.", true),
    createData('Outsource', "Make an arrangement where an external organisation performs part of an organisation's function.", true),
    createData('Audit', "Systematic, independent and documented process for obtaining audit evidence and evaluating it objectively to determine the extent to which the audit criteria are fulfilled.", true),
    createData('Nonconformity', "Non-fulfillment of a requirement.", true),
];

const muiColumns = [
    { title: 'Term', field: 'name'},
    { title: 'Definition', field: 'description', headerStyle: { width: "50%" } },
];

class TermsAndDefinitions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            organisation: null,
            orgId: "",
            termsAndDefinitions: [],
            isLoading: true,
        };

        this.loadOrganisationDetails = this.loadOrganisationDetails.bind(this);
        this.isValid = this.isValid.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.export = this.export.bind(this);
    }

    componentDidMount() {
        this.loadOrganisationDetails();
    }

    loadOrganisationDetails() {
        organisationDetails()
            .then(response => {
                console.log(response);
                let merged = response.termsAndDefinitions.concat(rows).sort(function(a, b) {
                    return compareStrings(a.name, b.name);
                });
                this.setState({
                    organisation: response,
                    orgId: response.id,
                    termsAndDefinitions: merged,
                    isLoading: false
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    isValid(newData) {
        let isValid = newData.name && newData.name !== '' && newData.description && newData.description !== '';
        if (!isValid) {
            NotificationManager.error('Error', 'Validation Error. Name and Description are required fields', 5000);
        }
        return isValid;
    }

    handleUpdate(toUpdate) {
        console.log("updating to ", toUpdate);
        for (let i = 0, l = this.state.organisation.termsAndDefinitions.length; i < l; i++) {
            if (this.state.organisation.termsAndDefinitions[i].id === toUpdate.id) {
                this.state.organisation.termsAndDefinitions[i].name = toUpdate.name;
                this.state.organisation.termsAndDefinitions[i].description = toUpdate.description;
            }
        }
        console.log("After update:", this.state.organisation.termsAndDefinitions);
        this.handleSubmit(this.state.organisation.termsAndDefinitions);
    }

    handleDelete(toDelete) {
        let termsAndDefinitions = [];
        const index = this.state.organisation.termsAndDefinitions.findIndex(x => x.id === toDelete.id);
        for (let i = 0, l = this.state.organisation.termsAndDefinitions.length; i < l; i++) {
            if (i !== index) {
                termsAndDefinitions.push(this.state.organisation.termsAndDefinitions[i]);
            }
        }
        console.log("After removal:", termsAndDefinitions);
        this.handleSubmit(termsAndDefinitions);
    }

    handleAdd(data) {
        this.state.organisation.termsAndDefinitions.push(data);
        this.handleSubmit(this.state.organisation.termsAndDefinitions);
    }

    handleSubmit(data) {
        this.state.organisation.termsAndDefinitions = data;
        saveOrUpdateOrganisationDetails(this.state.organisation)
            .then(() => {
                NotificationManager.success('Success', 'The Terms and Definitions have been updated.', 5000);
                this.loadOrganisationDetails();
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    export() {
        exportReport('/organisation/export/TERMS_AND_DEFINITIONS');
    }

    render() {
        let { isLoading } = this.state;
        if (isLoading) {
            return null;
        }
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        return <div>
            <Typography component="h2" variant="h5">
                TERMS AND DEFINITIONS
            </Typography>
            <Paper className={classes.root} style={{ marginTop: '30px' }}>
                <MuiTable
                    title="Terms and Definitions"
                    columns={muiColumns}
                    data={this.state.termsAndDefinitions}
                    onAdd={this.handleAdd}
                    onUpdate={this.handleUpdate}
                    onDelete={this.handleDelete}
                    isValid={this.isValid}
                    exportButton={!isDemo}
                    onExport={this.export}
                    allowUpdateDelete={isAuditor ? 'no' : 'yes'}
                    pageSize={10}
                />
            </Paper>
            <NotificationContainer/>
        </div>
        ;
    }
}

export default withStyles(classes)(TermsAndDefinitions);